/**
 * Documents / Atlas / Ask Insights stay on module pages (Dashboard, Vault,
 * Atlas, /ai). Insights home and Subject Workspace already have those
 * destinations in-page (home cards, Open in Atlas, Ask). Hiding the header
 * path there is intentional — not a responsive omission.
 */
export function hideStaffKnowledgePath(pathname: string): boolean {
  return pathname === "/" || pathname.startsWith("/subject/");
}
